import { Link } from "react-router-dom";
import "./InfoCard.css";
import "./HomeFlipCard.css";

type HomeFlipCardProps = {
  image: string;
  altText: string;
  imageTitle?: string;
  body: string;
  buttonText: string;
  link: string;
};

const HomeFlipCard = ({
  image,
  altText,
  imageTitle,
  body,
  buttonText,
  link,
}: HomeFlipCardProps) => {
  const label = imageTitle ?? buttonText;

  return (
    <div className="home-flip-card">
      <div className="home-flip-card-inner">
        <div className="home-flip-card-front">
          <div className="info-card-img-container">
            <img className="home-flip-card-img" src={image} alt={altText} />
            {imageTitle && (
              <h3 className="info-card-img-title">{imageTitle}</h3>
            )}
          </div>
        </div>
        <div className="home-flip-card-back">
          <div
            className="home-flip-card-back-blur"
            style={{ backgroundImage: `url(${image})` }}
            aria-hidden
          />
          <div className="home-flip-card-back-content">
            <p className="home-flip-card-text">{body}</p>
          </div>
        </div>
      </div>
      <Link
        to={link}
        className="home-flip-card-link"
        aria-label={`${label}: ${body}`}
      />
    </div>
  );
};

export default HomeFlipCard;
